import { gql, type MutationHookOptions, useMutation } from "@apollo/client";

interface DataType {
  saveGame: {
    clientMutationId?: string;
  };
}

interface VariablesType {
  input: {
    game: string;
  };
}

const MUTATION = gql`
  mutation SaveGame($input: WishlistSaveMutationInput!) {
    saveGame(input: $input) {
      clientMutationId
    }
  }
`;

export default function useSaveGameMutation(
  props?: MutationHookOptions<DataType, VariablesType>
) {
  return useMutation<DataType, VariablesType>(MUTATION, props);
}
